import { TaxServiceOptions } from '../../enums';
import { GenericCheckboxStep } from './GenericCheckboxStep';

function ServicesStep() {
  return (
    <GenericCheckboxStep
      title="What do you need help with?"
      subtitle="This will give your pro an idea of how they can serve you."
      checkboxOptions={TaxServiceOptions}
      referralFieldName="interests"
      stepName="services_step"
    />
  );
}

export { ServicesStep };
